import { Modal, ModalProps } from "@mantine/core";

export const CustomModal = (props: ModalProps) => {
  const { children, ...rest } = props;

  // console.log("CustomModal", props, children, rest);

  return <Modal {...rest}>{children}</Modal>;
};
